import { Capacitor, CapacitorHttp } from '@capacitor/core';

// On native (iOS/Android) WKWebView the app origin is capacitor://localhost, so remote
// images loaded via <img crossOrigin> taint the canvas and break getImageData/toDataURL.
// Fetch the bytes through CapacitorHttp (bypasses CORS) and return a same-origin data URL.
export async function ResolveImageSrc(src) {
  if (!src || !Capacitor.isNativePlatform()) return src;

  try {
    const response = await CapacitorHttp.get({ url: src, responseType: 'blob' });
    const headers = response.headers || {};
    const contentType = headers['Content-Type'] || headers['content-type'] || 'image/png';
    return `data:${contentType};base64,${response.data}`;
  } catch (error) {
    console.error('ResolveImageSrc error:', error);
    return src;
  }
}

export function LoadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous'; // если картинка с сервера
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

/**
 * ApplyMask function takes the URL of a black and white mask image
 * and converts it into a semi-transparent overlay.
 */
export async function ApplyMask (maskSrc) {
  const resolvedSrc = await ResolveImageSrc(maskSrc);
  const mask = await LoadImage(resolvedSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  canvas.width = mask.width;
  canvas.height = mask.height;

  ctx.drawImage(mask, 0, 0);

  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;

  for (let i = 0; i < data.length; i += 4) {
    const pixel = data[i]; // R channel (0 or 255)

    if (pixel > 127) {
      // white (1, crops) → transparent
      data[i] = 0;
      data[i + 1] = 0;
      data[i + 2] = 0;
      data[i + 3] = 0;
    } else {
      // black (0, soil, not crops) → red semi-transparent
      data[i] = 87;
      data[i + 1] = 49;
      data[i + 2] = 33;
      data[i + 3] = 255; // 0...255
    }
  }

  ctx.putImageData(imageData, 0, 0);

  return canvas.toDataURL('image/png')
}